<template>
  <div class="h-screen w-full">
    <div class="flex flex-col items-center justify-center h-screen m-auto w-10/12 md:w-2/5">
      <slot></slot>
    </div>
  </div>
</template>
